import config from '../config/Amplify';

/**
 * @typedef {Object} FeatureFlags
 * @property {boolean} [enablePriorityButton] Enables the job priority button in the job actions pane.
 * @property {boolean} [isEntraLoginEnabled] Enables direct Entra login and the associated Entra logout flow.
 */

class FeatureFlagService {
    static instance = null;

    /** @type {FeatureFlags} */
    _featureFlags = {};

    constructor() {
        // noinspection ES6ModulesDependencies
        if (FeatureFlagService.instance) {
            // noinspection ES6ModulesDependencies
            return FeatureFlagService.instance;
        }

        /** @type {FeatureFlags} */
        this._featureFlags = config.FeatureFlags;
        FeatureFlagService.instance = this;
    }

    static getInstance() {
        if (!FeatureFlagService.instance) {
            FeatureFlagService.instance = new FeatureFlagService();
        }
        return FeatureFlagService.instance;
    }

    /**
     * Returns all feature flags from configuration
     * @returns {FeatureFlags} Object containing all feature flags
     */
    getFeatureFlags() {
        return this._featureFlags;
    }

    _isProduction() {
        return import.meta.env.VITE_APP_STAGE === 'Prod';
    }

    _isTestingEnv() {
        return (window.location.host.match(/gmg-dev/) || window.location.host.match(/gmg-test/));
    }

    _isLocalDevEnv() {
        return !this._isProduction() && !this._isTestingEnv();
    }
}

export { FeatureFlagService };
